var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.notes),function(note){return _c('div',{key:note.id,staticClass:"column is-3"},[_c('Note',{attrs:{"note":note,"editable":false}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }